import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiBalance } from "@/shared/api/balance/api-balance";
import { type EnableAutoTopUpRequest } from "@/shared/api/types";
import { getServerMessage } from "@/shared/lib/apiErrorHandler";

type MutationVariables = {
  autoTopUpId: string;
  data: EnableAutoTopUpRequest;
};

const apiBalance = new ApiBalance();

export const useEnableAutoTopUp = () => {
  const queryClient = useQueryClient();

  // Дженерики заданы явно: тип ошибки — Error, потому что onError ниже
  // нормализует любой отказ в Error. Вызывающий (AutoTopUpForm) читает
  // error.message, и без этого он получал бы unknown.
  return useMutation<
    Awaited<ReturnType<typeof apiBalance.enableAutoTopUp>>,
    Error,
    MutationVariables
  >({
    mutationFn: ({ autoTopUpId, data }) =>
      apiBalance.enableAutoTopUp(autoTopUpId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["auto-top-up"] });
    },
    onError: (error) => {
      throw new Error(
        getServerMessage(error, "Не удалось включить автопополнение"),
      );
    },
  });
};
